import { gql } from '@apollo/client';

export default gql`
  fragment CoderConnectionFields on CoderConnection {
    id
    __typename
  }
`;
